export default __webpack_public_path__ + "static/media/8_Manuel Cabrera_179x177.0cc15013.webp";